import { type FC } from "react";

import { TEXTS } from "../../constants";
import MovedToTemplatesNotice from "./MovedToTemplatesNotice";

const BrandingForm: FC = () => (
  <MovedToTemplatesNotice message={TEXTS.movedToTemplates.branding} />
);

export default BrandingForm;
